export var routes = {
    home: '/',
    dashboard: '/',
    callback: '/callback',
    logout: '/logout',
    expiredToken: '/expired-token',
    onboarding: '/onboarding',
    onboardingSupplierStep2: '/onboarding/supplier-step-2',
    onboardingSupplierStep1: '/onboarding/supplier-step-1',
    activate: '/activate',
    faq: '/faq',
    support: '/support',
    account: '/account',
    checkout: {
        paymentSuccess: '/checkout/success',
        paymentCancel: '/checkout/cancel',
    },
    login: {
        base: '/login',
        start: '/login',
        finish: '/login/finish',
    },
    register: {
        base: '/register',
        start: '/register',
        user: '/register/activate',
        organization: '/register/organization',
    },
    overview: {
        base: '/',
        dashboard: '/',
        reports: '/reports/',
        viewReport: '/reports/:boardKey',
    },
    log: {
        base: '/log',
        tags: '/log/tags',
        productLogs: '/log/products',
        customReport: '/log/closed-periods/:id',
        carbonFootprint: {
            base: '/log/carbon-footprint',
            organization: {
                base: '/log/carbon-footprint/organization',
                edit: '/log/carbon-footprint/organization/:id',
            },
            products: {
                base: '/log/carbon-footprint/products',
                create: '/log/carbon-footprint/products/create',
                productDetails: '/log/carbon-footprint/products/:productId',
                edit: '/log/carbon-footprint/products/:id/edit',
                logs: '/log/carbon-footprint/products/:id/logs',
            },
            productsUpsert: {
                base: '/log/carbon-footprint/products/flow',
                stepsCreate: '/log/carbon-footprint/products/flow/create/steps',
                stepsEdit: '/log/carbon-footprint/products/flow/:id/edit/steps',
                configurationCreate: '/log/carbon-footprint/products/flow/create/configuration',
                configurationEdit: '/log/carbon-footprint/products/flow/:id/edit/configuration',
                quantitiesCreate: '/log/carbon-footprint/products/flow/create/quantities',
                quantitiesEdit: '/log/carbon-footprint/products/flow/:id/edit/quantities',
                compositionCreate: '/log/carbon-footprint/products/flow/create/composition',
                compositionEdit: '/log/carbon-footprint/products/flow/:id/edit/composition',
                productionCreate: '/log/carbon-footprint/products/flow/create/production',
                productionEdit: '/log/carbon-footprint/products/flow/:id/edit/production',
                distributionAndStorageCreate: '/log/carbon-footprint/products/flow/create/distribution-and-storage',
                distributionAndStorageEdit: '/log/carbon-footprint/products/flow/:id/edit/distribution-and-storage',
                endOfLifeCreate: '/log/carbon-footprint/products/flow/create/end-of-life',
                endOfLifeEdit: '/log/carbon-footprint/products/flow/:id/edit/end-of-life',
                packagingCreate: '/log/carbon-footprint/products/flow/create/packaging',
                packagingEdit: '/log/carbon-footprint/products/flow/:id/edit/packaging',
                usageCreate: '/log/carbon-footprint/products/flow/create/usage',
                usageEdit: '/log/carbon-footprint/products/flow/:id/edit/usage',
            },
            productsUpdate: {
                base: '/log/carbon-footprint/products/:id/update',
                steps: '/log/carbon-footprint/products/:id/update/steps',
                configuration: '/log/carbon-footprint/products/:id/update/configuration',
                quantities: '/log/carbon-footprint/products/:id/update/quantities',
            },
            quantities: '/log/carbon-footprint/quantities',
            sales: '/log/carbon-footprint/sales',
            addClosedPeriod: '/log/carbon-footprint/closed-period',
            editClosedPeriod: '/log/carbon-footprint/closed-period/:id',
        },
        quantitiesLogs: '/log/quantities',
        bulkImport: {
            base: '/log/bulk-import/',
            create: '/log/bulk-import/create',
            list: '/log/bulk-import/list',
        },
        pastBulkImports: '/log/bulk-import/past-imports',
        reports: '/log/reports/',
        viewReport: '/log/reports/:boardKey',
        editLog: '/log/:id',
        factors: {
            base: '/log/factors',
            emissions: '/log/factors/emissions',
            requestsPage: '/log/factors/requests',
            request: '/log/factors/request',
            calculations: {
                base: '/log/factors/calculations',
                viewCalculation: '/log/factors/calculations/:id',
            },
        },
        suppliers: '/log/suppliers',
        'closed-periods': '/log/closed-periods',
        'customer-requests': '/log/customer-requests',
        customers: '/log/customers',
    },
    act: {
        base: '/act',
        marketplace: '/act/marketplace',
        basket: '/act/marketplace/basket',
        requests: '/act/marketplace/requests',
        request: '/act/marketplace/request/:id',
        climateActions: '/act/climate-actions',
        createClimateAction: '/act/climate-actions/new',
        editClimateAction: '/act/climate-actions/:id/edit',
        viewClimateAction: '/act/climate-actions/:id',
        inquiries: '/act/inquiries',
        actionAreas: '/act/actions-areas',
        targets: '/act/targets',
        newTarget: '/act/targets/new',
        editTarget: '/act/targets/:id',
        budgets: '/act/budgets',
        createBudget: '/act/budgets/new',
        editBudget: '/act/budgets/:id',
        solutions: '/act/solutions/:key',
        solutionsSearch: '/act/solutions',
        solution: '/act/marketplace/:id',
        offersPage: '/act/:id/offers',
        services: '/act/services',
        forecastSettings: '/act/forecast-settings',
        editForecastSettings: '/act/forecast-settings/:id',
    },
    share: {
        base: '/share',
        createStory: '/share/story/new',
        successStory: '/share/story',
        story: '/share/story/:storyId',
        addStory: '/share/story/new',
        editStory: '/share/story/:storyId/edit',
        stories: '/share/stories',
        certifications: '/share/certifications',
        sustainabilityReports: '/share/sustainability-reports',
        sharePages: '/share/share-pages',
        viewSharePage: '/share/share-pages/:slug',
    },
    organization: {
        base: '/log/organization',
        locations: {
            base: '/log/organization/locations',
            singleLocation: '/log/organization/locations/:locationId',
            logs: '/log/organization/locations/:locationId/logs',
            editLog: '/log/organization/locations/:locationId/logs/:id',
        },
        addLocation: '/log/organization/location',
        editLocation: '/log/organization/locations/:id/edit',
        businessUnits: '/log/organization/business-units',
        addBusinessUnit: '/log/organization/business-unit',
        editBusinessUnit: '/log/organization/business-units/:id',
        lifecycleSteps: '/log/organization/products/lifecycle-steps',
        organigram: '/log/organization/organigram',
    },
    settings: {
        base: '/settings',
        organization: '/settings/organization',
        data: '/settings/data',
        api: '/settings/api',
        functions: '/settings/functions',
        subscription: '/settings/subscription',
        plans: '/settings/plans',
        users: '/settings/users',
        editUser: '/settings/user/:id',
        addUser: '/settings/user/',
        profile: '/settings/profile',
        integrations: '/settings/integrations',
        installIntegration: '/settings/integrations/:id',
    },
    password: {
        base: '/password',
        requestReset: '/password/request',
        submitReset: '/password/reset',
    },
};
//# sourceMappingURL=dashboard-routes.js.map